import { useRouter } from 'next/router';
import { markets } from 'constants/markets';

/**
 * Prefixes internal MY Customers links with `/sv` for the Swedish-in-Finland (sefi)
 * market. The prefix is derived from Next's active `locale` (deterministic per
 * request/route: `sv-FI` for sefi) rather than the client `useMarket` store, which
 * is not reliably set to `sefi` at render time (SSR default + hydration timing) and
 * previously caused menu links to lose the `/sv` prefix -> Finnish market.
 */
export function useFormatMyCustomersLink() {
    const { locale } = useRouter();
    const prefix = locale === markets.sefi.locale ? '/sv' : '';
    const formatLink = (link: string) => (link.startsWith('http')
        ? link
        : `${prefix}${link}`);

    return { formatLink };
}
